import { initialState, StoresState } from './selectors';
import * as actions from './actions';

export default (
  state: StoresState = initialState,
  action: actions.StoresAction,
) => {
  switch (action.type) {
    case actions.STORES_CITIES_ACTIONS.REQUESTED: {
      return { ...state, citiesLoading: true };
    }

    case actions.STORES_CITIES_ACTIONS.SUCCEEDED: {
      const {
        payload: { regions, country },
      } = action as actions.CitiesSucceeded;

      return { ...state, regions, country, citiesLoading: false };
    }

    case actions.STORES_ACTIONS.REQUESTED: {
      const { region } = action as actions.StoresRequested;
      return { ...state, openCity: region, storesLoading: true };
    }

    case actions.STORES_ACTIONS.SUCCEEDED: {
      const {
        payload: { stores },
      } = action as actions.StoresSucceeded;
      return { ...state, stores, storesLoading: false };
    }

    case actions.REMOVE_STORE_ACTIONS.SUCCEEDED: {
      const {
        payload: { storeId },
      } = action as any;

      const stores = state.stores.filter(store => store.id !== storeId);

      return { ...state, stores };
    }

    case actions.REMOVE_ENTITY_ACTIONS.SUCCEEDED:
    case actions.EDIT_ENTITY_ACTIONS.SUCCEEDED:
      return { ...state, ...initialState };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/reducer.ts